import { useField } from '~/hooks';
import React from 'react';
import styled from 'styled-components';
import { taskTypeColors } from '~/components/taskTypeColors';
import FieldControl from '~/components/FieldControl';
import SingleSelect from '~/components/SingleSelect';

const ColorSwatch = styled.span`
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border-radius: 0.1875rem;
  background-color: ${({ color }) => color};
  margin-right: 0.5rem;
  flex-shrink: 0;
`;

const ColorOption = styled.span`
  display: flex;
  align-items: center;
`;

function FieldColorSelect({ placeholder = 'Color', ...props }) {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;

  const renderValue = (value) => {
    const color = taskTypeColors.find((c) => c.id === value);
    if (!color) return null;
    return (
      <ColorOption>
        <ColorSwatch color={color.hex} />
        {color.name}
      </ColorOption>
    );
  };

  return (
    <FieldControl error={error}>
      <SingleSelect {...field} {...props} placeholder={placeholder} valueRenderer={renderValue}>
        {taskTypeColors.map((color) => (
          <option key={color.id} value={color.id}>
            <ColorOption>
              <ColorSwatch color={color.hex} />
              {color.name}
            </ColorOption>
          </option>
        ))}
      </SingleSelect>
    </FieldControl>
  );
}

export default FieldColorSelect;
